import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { IconContext } from "react-icons";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import "../components/component.css";
import { TimelineServiceItem } from "./TimelineServiceItem";
import { useIntl } from "react-intl";
import { EXAMS_STATUS_ID } from "../utils/jsCostants";
import { findUrgencyCodeDescriptionId } from "../utils/findUrgencyByCode";

export const CardPatientTotem = ({ encounter }) => {

  const intl = useIntl();

  const renderEncounterServices = encounter => {
    const { code: { code }, services, period, generalStatus, dischargeDisplay } = encounter;

    // Requested services go at the end.
    const sortedServices = services.sort((serviceA, serviceB) => {
      if (serviceA.status === EXAMS_STATUS_ID.RICHIESTO && serviceB.status === EXAMS_STATUS_ID.RICHIESTO) {
        return 0;
      }
      if (serviceA.status === EXAMS_STATUS_ID.RICHIESTO) {
        return 1;
      }
      if (serviceB.status === EXAMS_STATUS_ID.RICHIESTO) {
        return -1;
      }
      return 0;
    });

    const acceptance = {};
    const newServizi = [acceptance, ...sortedServices];

    return newServizi.map((el, index) => (
      <TimelineServiceItem
        key={index}
        period={period}
        status={el.status}
        type={el.type}
        generalStatus={generalStatus}
        descriptionDischargeDisplay={dischargeDisplay}
        index={index}
        lengthServicesArray={newServizi.length}
        descriptionUrgency={Number.parseInt(code) !== -1 ? intl.formatMessage({ id: findUrgencyCodeDescriptionId(code) }) : ""}
        dischargeDisplayContainerClass={'container-discharge-display-totem'}
      />
    ));
  };

  return (
    <React.Fragment>
      {!encounter ?
        (
          <Card className="border-0" style={{ marginTop: "2.5%" }}>
            <Card
              className="border-0 border-card"
              style={{ minWidth: "min-content", marginTop: "18%", marginBottom: "8%" }}
            >
              <Card.Title className="border-card">
                <Row className=" justify-content-center">
                  <Col>
                    <Card
                      className="align-items-center border-0"
                      style={{
                        minWidth: "min-content",
                        marginBottom: "2.5%"
                      }}
                    >
                      <IconContext.Provider
                        value={{
                          color: "gray",
                          className: "global-class-name"
                        }}
                      >
                        <div style={{ fontSize: "200%" }}>
                          <AiOutlineUsergroupAdd />
                        </div>
                      </IconContext.Provider>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div
                      className="text-center"
                      style={{
                        fontSize: "60%",
                        WebkitTextFillColor: "gray"
                      }}
                    >
                      {intl.formatMessage({ id: 'monitoraggioPazientePage.nessunCodiceContatto' })}
                    </div>
                  </Col>
                </Row>
              </Card.Title>
              <Card.Text className="text-center">
                <span
                  className="d-flex justify-content-center"
                  style={{
                    fontSize: "50%",
                    WebkitTextFillColor: "gray"
                  }}
                >
                  {intl.formatMessage({ id: 'monitoraggioPazientePage.trovaloSuFoglioAccettazione' })}
                </span>
              </Card.Text>
            </Card>
          </Card>
        )
        : (
          <Card style={{ borderRadius: "12pt", marginTop: '2rem' }} className="shadow card-timeline border-card">
            <Card.Body style={{ padding: '0 1em' }}>
              <Row>
                <Col xs="12">
                  {renderEncounterServices(encounter)}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}
    </React.Fragment>
  );
};
